/**
 * VENDOR MODULES
 */
import React from 'react';
import i18n from "i18n";

import GridOdd from 'shared/components/outcomes/grids/GridOdd';

/**
 * Renders the Double Chance outcomes for football
 * HOME_DRAW (1X), DRAW_AWAY (X2), HOME_AWAY (12)
 *
 * @class  DoubleChance (name)
 * @param  {Object}   props The properties
 * @return {JSX}
 */
function DoubleChance(props) {
  const {
    outcomes = {},
    homeTeamName = 'Home',
    awayTeamName = 'Away',
    event,
    oddVariant = 'grid-odd-football',
  } = props;

  // Filter for market type 5002 (Double Chance)
  const dcOutcomes = Object.values(outcomes)
    .filter(x => parseInt(x.market_type_id) === 5002);

  // Sort outcomes in logical order
  const outcomeOrder = ['HOME_DRAW', 'DRAW_AWAY', 'HOME_AWAY'];
  const sortedOutcomes = dcOutcomes.sort((a, b) => {
    return outcomeOrder.indexOf(a.outcome) - outcomeOrder.indexOf(b.outcome);
  });

  // Get individual outcomes
  const homeDrawOutcome = sortedOutcomes.find(o => o.outcome === 'HOME_DRAW');
  const drawAwayOutcome = sortedOutcomes.find(o => o.outcome === 'DRAW_AWAY');
  const homeAwayOutcome = sortedOutcomes.find(o => o.outcome === 'HOME_AWAY');

  return (
    <div className="double-chance-grid">
      <div className="grid grid-cols-3 gap-3 p-3 border-b border-gray-100">
        {/* Home or Draw (1X) */}
        <div className="w-full">
          {homeDrawOutcome && (
            <GridOdd
              {...{
                ...homeDrawOutcome,
                class_names: [oddVariant, 'bg-background/80', 'w-full', 'p-4', 'min-h-[72px]'],
                market_type_group_id: 509,
                display_label: '1X',
                event
              }}
            />
          )}
        </div>
        
        {/* Draw or Away (X2) */}
        <div className="w-full">
          {drawAwayOutcome && (
            <GridOdd
              {...{
                ...drawAwayOutcome,
                class_names: [oddVariant, 'bg-background/80', 'w-full', 'p-4', 'min-h-[72px]'],
                market_type_group_id: 509,
                display_label: 'X2',
                event
              }}
            />
          )}
        </div>
        
        {/* Home or Away (12) */}
        <div className="w-full">
          {homeAwayOutcome && (
            <GridOdd
              {...{
                ...homeAwayOutcome,
                class_names: [oddVariant, 'bg-background/80', 'w-full', 'p-4', 'min-h-[72px]'],
                market_type_group_id: 509,
                display_label: '12',
                event
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default DoubleChance;

